module.exports = __webpack_public_path__ + "public/Icons/Language-icon.svg?12101838";